import { render } from "./TechnicalSupport.vue?vue&type=template&id=a000c712&scoped=true"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js"

import "./TechnicalSupport.vue?vue&type=style&index=0&id=a000c712&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a000c712"]])

export default __exports__